<template>
  <div>
  <el-dialog
    :visible="showViewNetPlane"
    :show-close="true"
    fullscreen
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose">
    <el-page-header @back="handleClose()" content="网络平面" title="返回">
    </el-page-header>
    <canvas id="canvas"  height="600" width="1200"></canvas>
  </el-dialog>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  export default {
    name: "JtopoNetPlane",
    data() {
      return {
        myChart:null,
        mapHeight:500,
        nodeData: [],
        nodeLinks: [],
        count: 1,
        r: 30
      }
    },
    computed: {
      ...mapState('main', ['tableHeight'])
    },
    methods: {
      handleClose(){
        this.$emit('editCallback')
      },
      initMap(){
        let _this = this;
        let canvas = document.getElementById('canvas');
        let stage = new JTopo.Stage(canvas);
        let scene = new JTopo.Scene();
        stage.add(scene);
        stage.wheelZoom = 1.01
        let cloudNode = null;
        cloudNode = new JTopo.Node(this.viewNetPlaneItme.netPlaneName);
        cloudNode.setSize(30, 26);
        cloudNode.setLocation(100,100);
        cloudNode.fontColor = '1,43,21';
        cloudNode.fillColor = '193,200,3';
        cloudNode.layout = {type: 'tree',direction: 'right', width:150, height: 120}
        scene.add(cloudNode);
        if(!_this.nodeData || _this.nodeData.length == 0){
          cloudNode.setLocation(100,100);
          return
        }
        let map = new Map();
        for(let i=0; i<_this.nodeData.length; i++){
          let obj = _this.nodeData[i];
          let node = null;
          if(obj.type == 1){
            node = new JTopo.CircleNode(obj.netPlaneName);
            node.fillColor = '200,255,12';
            node.radius = 25;
          }else {
            node = new JTopo.Node(obj.netPlaneName);
            let color = map.get(obj.id)
            if(color){
              node.fillColor = color;
            }else {
              color = _this.randomRgb()
              map.set(obj.id, color)
              node.fillColor = color;
            }
            node.radius = 15;
          }
          node.fontColor = '1,43,21'
          node.setLocation(scene.width * Math.random(), scene.height * Math.random());
          node.layout = {type: 'tree',direction: 'right', width:100, height: 100};
          scene.add(node);
          let link = new JTopo.Link(cloudNode, node);
          link.arrowsRadius = 10;
          scene.add(link);
          if(obj.accessNetPlaneList && obj.accessNetPlaneList.length > 0){
            _this.handleChildData(obj.accessNetPlaneList,scene,node,map);
          }
        }
        stage.centerAndZoom(0);
        JTopo.layout.layoutNode(scene, cloudNode, true);
        scene.addEventListener('mouseup', function(e){
          if(e.target && e.target.layout){
            JTopo.layout.layoutNode(scene, e.target, true);
          }
        });
      },
      randomRgb(){
        const R = Math.floor(Math.random() * 155);
        const G = Math.floor(Math.random() * 255);
        const B = Math.floor(Math.random() * 155);
        return  R + ',' + G + ',' + B
      },
      initData() {
        var data = {
          'id': this.viewNetPlaneItme.id
        };
        var _this = this;
        this.$axios.post(this.baseUrl3 + 'management3/netplane/netplaneaccesslist', data)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              _this.nodeData = data;
              this.$nextTick(() => {
                _this.initMap()
              })
            } else {
              _this.$message({showClose: true, message: msg, type: 'error'})
              console.log(msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      handleChildData( data ,scene,node,map){
        let _this = this;
        for(let j=0; j<data.length; j++){
          let obj = data[j];
          let vmNode = null;
          if(obj.type == 1){
            vmNode = new JTopo.CircleNode(obj.netPlaneName);
            vmNode.fillColor = '200,255,12';
            vmNode.radius = 25;
          }else {
            vmNode = new JTopo.Node(obj.netPlaneName);
            //vmNode.fillColor = '47,227,5';
            let color = map.get(obj.id);
            if(color){
              vmNode.fillColor = color;
            }else {
              color = _this.randomRgb()
              map.set(obj.id, color)
              vmNode.fillColor = color;
            }
            vmNode.radius = 15;
          }
          vmNode.fontColor = '1,43,21'
          vmNode.setLocation(scene.width * Math.random(), scene.height * Math.random());
          vmNode.layout = {type: 'tree',direction: 'right', width:100, height: 100};
          scene.add(vmNode);
          let link = new JTopo.Link(node, vmNode);
          link.arrowsRadius = 10;
          scene.add(link);
          if(obj.accessNetPlaneList && obj.accessNetPlaneList.length > 0){
            _this.handleChildData(obj.accessNetPlaneList,scene,vmNode,map);
          }
        }
      },
    },
    created() {
      this.initData();
    },
    mounted() {
      this.mapHeight = this.tableHeight?this.tableHeight+20:530;
    },
    props: {
      showViewNetPlane: {
        type: Boolean
      },
      viewNetPlaneItme: {
        type: Object
      }
    },
  }
</script>

<style scoped>

</style>
